import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin } from 'lucide-react'

const FacebookIcon = (p: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={p.size ?? 16} height={p.size ?? 16} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06c0 5.01 3.66 9.16 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.78-3.91 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.91h-2.33V22c4.78-.78 8.42-4.93 8.42-9.94z" />
  </svg>
)

const TwitterIcon = (p: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={p.size ?? 16} height={p.size ?? 16} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)

const InstagramIcon = (p: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={p.size ?? 16} height={p.size ?? 16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
)

const LinkedinIcon = (p: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={p.size ?? 16} height={p.size ?? 16} viewBox="0 0 24 24" fill="currentColor">
    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.11 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v14H.22V8zm7.5 0h4.37v1.92h.06c.61-1.15 2.1-2.36 4.33-2.36 4.63 0 5.48 3.05 5.48 7.02V22h-4.56v-6.24c0-1.49-.03-3.4-2.07-3.4-2.07 0-2.39 1.62-2.39 3.29V22H7.72V8z" />
  </svg>
)

export function LandingFooter() {
  return (
    <footer className="bg-[#fff8f4] border-t border-primary/10 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 bg-gradient-to-br from-primary-dark to-primary rounded-lg flex items-center justify-center shadow-md shadow-primary/25">
                <span className="text-white font-heading font-extrabold">N</span>
              </div>
              <span className="text-lg font-heading font-extrabold text-text-primary">
                Nova<span className="text-primary">Muhasebe</span>
              </span>
            </Link>
            <p className="text-text-secondary text-sm mb-6 leading-relaxed">
              Türkiye'nin modern ve kullanıcı dostu ön muhasebe çözümü.
              İşletmenizi dijitalleştirin, hesabınızı bilin.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: FacebookIcon, label: 'Facebook' },
                { Icon: TwitterIcon, label: 'Twitter' },
                { Icon: InstagramIcon, label: 'Instagram' },
                { Icon: LinkedinIcon, label: 'LinkedIn' },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  className="w-9 h-9 rounded-full bg-white border border-primary/10 flex items-center justify-center text-text-secondary hover:bg-primary hover:text-white hover:border-primary transition-all"
                  aria-label={label}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-text-primary font-heading font-bold mb-5">Ürün</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/#ozellikler" className="text-text-secondary hover:text-primary transition-colors text-sm">Özellikler</Link></li>
              <li><Link to="/fiyatlandirma" className="text-text-secondary hover:text-primary transition-colors text-sm">Fiyatlandırma</Link></li>
              <li><Link to="/#nasil-calisir" className="text-text-secondary hover:text-primary transition-colors text-sm">Nasıl Çalışır?</Link></li>
              <li><Link to="/deneme-kayit" className="text-text-secondary hover:text-primary transition-colors text-sm">Ücretsiz Deneme</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-text-primary font-heading font-bold mb-5">Şirket</h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/hakkimizda" className="text-text-secondary hover:text-primary transition-colors text-sm">Hakkımızda</Link></li>
              <li><Link to="/blog" className="text-text-secondary hover:text-primary transition-colors text-sm">Blog</Link></li>
              <li><Link to="/kariyer" className="text-text-secondary hover:text-primary transition-colors text-sm">Kariyer</Link></li>
              <li><Link to="/gizlilik" className="text-text-secondary hover:text-primary transition-colors text-sm">Gizlilik</Link></li>
              <li><Link to="/sartlar" className="text-text-secondary hover:text-primary transition-colors text-sm">Kullanım Şartları</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-text-primary font-heading font-bold mb-5">İletişim</h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li className="flex items-start gap-2 text-text-secondary">
                <Mail size={16} className="text-primary shrink-0 mt-0.5" />
                <a href="mailto:destek@novamuhasebe.com" className="hover:text-primary transition-colors">
                  destek@novamuhasebe.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-text-secondary">
                <Phone size={16} className="text-primary shrink-0 mt-0.5" />
                <a href="tel:+908502221234" className="hover:text-primary transition-colors">
                  0 (850) 222 12 34
                </a>
              </li>
              <li className="flex items-start gap-2 text-text-secondary">
                <MapPin size={16} className="text-primary shrink-0 mt-0.5" />
                <span>Teknopark İstanbul, Pendik / İstanbul</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-text-muted text-sm">
            © {new Date().getFullYear()} iNova Muhasebe. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/gizlilik" className="text-text-muted hover:text-primary transition-colors">Gizlilik</Link>
            <Link to="/sartlar" className="text-text-muted hover:text-primary transition-colors">Şartlar</Link>
            <Link to="/cerez" className="text-text-muted hover:text-primary transition-colors">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
